"use client";
import React, { useEffect, useState } from "react";
// import footerData from '../../data/footer.json';
import Image from "next/image";
import smallLogo from "../../assets/smallLogo.svg";
import { EventData, MainMenus, MenuItem } from "@/types/common";
import Link from "next/link";
// import { usePathname } from "next/navigation";
import { pageService } from "@/services/pageServices";
// import Script from "next/script";
import { matchSiteConfig } from "@/utils/getApiBaseUrl";
import GumletImage from "@/utils/GumletSrcSet";
// import { useLayout } from '@/context/LayoutContext';
// import { adsService } from '@/services/adsService';
// import { useAuth } from "@/context/AuthContext";

// Separate components for better organization and reusability
const SocialLinks = ({ links }: { links: MenuItem[] }) => (
  <div className="mb-10 flex justify-center space-x-6 lg:flex-row flex-wrap">
    {links?.map((item, index) => (
      <Link
        key={`SocialMenu-${index}`}
        target="_blank"
        href={item.href || "#"}
        className="text-gray-300 hover:text-white transition-colors h-6 w-6 relative items-center"
        prefetch={false}
      >
        {item.icon ? (
          <GumletImage
            // src={`/assets/${item.icon}`}
            imageUrl={item.icon}
            alt={item.label}
            fill
            className="object-contain"
          />
        ) : (
          ""
        )}
      </Link>
    ))}
  </div>
);

const FooterSection = ({
  links,
  // isLastSection,
}: {
  links: MenuItem[];
  // isLastSection: boolean;
}) => {
  return (
    <div>
      <h3 className="text-white font-semibold text-base mb-4">
        {links[0]?.label}
      </h3>
      {/* <ul className={`space-y-2 h-auto ${!isLastSection ? ' lg:border-r pr-4 border-white/20' : ''}`}> */}
      <ul className={`space-y-2 `}>
        {links?.map((item, index) => {
          if (index === 0) return null;
          return (
            <li key={`FooterSection-${index}`}>
              <Link
                href={item.href || "#"}
                className="text-gray-300 text-sm whitespace-nowrap hover:text-white text-opacity-70 transition-colors"
                prefetch={false}
              >
                {item.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const CircularImage = ({ menuItem }: { menuItem: MenuItem }) => (
  <Link href={menuItem.href || "#"} target="_blank" className="block" prefetch={false}>
    <div className="aspect-square rounded-full w-[91px] bg-gray-800 overflow-hidden">
      <GumletImage
        imageUrl={menuItem.icon}
        fallbackSrc="/assets/images/dummy.jpg"
        alt={menuItem.label}
        width={91}
        height={91}
        className="w-full h-full object-cover hover:opacity-75 transition-opacity"
      />
      {/* <label className="text-white text-sm mt-2 block text-center">{menuItem.label}</label> */}
    </div>
  </Link>
);
const MainFooter = ({ menuItems }: { menuItems: MainMenus }) => {
  // const { pageType } = useLayout();
  // const pathname = usePathname();
  const [siteType, setSiteType] = useState<string>("");
  // const { siteType } = matchSiteConfig(
  //   typeof window !== "undefined" ? window.location.hostname : ""
  // );
  useEffect(() => {
    const { siteType } = matchSiteConfig(window.location.hostname);
    setSiteType(siteType);
  }, []);


  // const productList = [
  //   {
  //     icon: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/16d0ba29-7ea3-46af-abb6-d507ba197772.png`,
  //     label: "Product 1",
  //     href: "https://shrparesearch.peoplemattersglobal.com/",
  //   },

  //   {
  //     icon: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/46e1bfdb-f7f9-44ee-aec5-8cb4b896e27b.png`,
  //     label: "Product 1",
  //     href: "https://www.pmoctopus.ai/",
  //   },
  //   {
  //     icon: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/06ed1dfa-de9f-4835-aaf8-80b127d086f4.png`,
  //     label: "Product 1",
  //     href: "https://www.youtube.com/watch?v=lP7A5Y02URw&list=PLj-piXayi-sz3-upVRsvJpdWyP8emUyrA",
  //   },
  // ];
  const productList = menuItems.OurProducts ?? [];

  useEffect(() => {
    const fetchAds = async () => {
      try {
        // const adsData = await adsService.getAdsJs(pathname as string);
      } catch (error) {
        console.error("Error fetching ads:", error);
      }
    };

    fetchAds();
  }, []);

  const [sectionsData] = useState<MenuItem[][]>([
    menuItems.FooterCol1 ?? [],
    menuItems.FooterCol2 ?? [],
    menuItems.FooterCol3 ?? [],
    menuItems.FooterCol4 ?? [],
    menuItems.FooterCol5 ?? [],
    menuItems.FooterCol6 ?? [],
    // menuItems.OurProducts ?? [],
  ]);

  const [eventData, setEventData] = useState<[] | null>(null);

  useEffect(() => {
    pageService
      .getEvents("all")
      .then((res) => {
        const eventData = Array.isArray(res?.data?.data)
          ? res?.data?.data.slice(0, 6).map((event: EventData) => ({
              ...event,
              icon: event?.thumbnail || event?.image || "/assets/images/dummy.jpg", // or prod?.image || "/assets/images/dummy.jpg"
              label: event?.title || "",
              href: `/event/${event?.slug}`,
            }))
          : [];

        setEventData(eventData);
      });
  }, []);
  return (
    <div className="bg-indigo px-4 sm:px-6 lg:px-8 xl:px-0">
      <footer className="bg-indigo text-gray-300 py-12 max-w-7xl mx-auto w-full">
        <div className="pb-10">
          <Image
            src={smallLogo}
            alt="logo"
            width={96}
            height={96}
            className="mx-auto"
            priority={false}
            sizes="max-width: 96px "
          />
        </div>

        <p className="text-white text-sm text-center mb-10 max-w-3xl mx-auto">
          Bringing you the latest HR trends, news, and insights from across the
          world of work.
          <br /> From leadership and culture to tech, talent, and the evolving
          workplace, we cover what matters most. Discover how today&apos;s ideas
          are shaping the way we work, lead, and grow.
        </p>
        <SocialLinks links={menuItems.SocialMenu ?? []} />

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 mb-8">
          {sectionsData?.map((section: MenuItem[], index: number) => {
            // const isLastSection = index === sectionsData?.length - 1;
            return (
              <FooterSection
                key={`FooterSection-${index}`}
                links={section}
                // isLastSection={isLastSection}
              />
            );
          })}
        </div>
        {/* Other Links */}
        {menuItems.OtherLinks && (
          <div className="flex gap-4 items-center">
            <div className="flex items-center gap-16 mb-8">
              <h3 className="text-white font-semibold">Other Links:</h3>
              <div className="flex gap-8">
                {(menuItems?.OtherLinks ?? []).map(({ label, href }) => (
                  <Link
                    key={label}
                    href={href || "#"}
                    className="text-sm text-white/60 hover:text-white transition-colors"
                    prefetch={false}
                  >
                    {label}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        )}

        <div className="border-t border-gray-800 pt-10">
          <div className="flex lg:flex-row flex-col justify-between gap-8 pb-5">
            {productList && productList?.length > 0 && (
              <div>
                <h3 className="text-base font-semibold mb-4">Our Products</h3>
                <div className="flex flex-wrap gap-8">
                  {productList?.map((product: MenuItem, index: number) => (
                    <CircularImage
                      key={`OurProducts-${index}`}
                      menuItem={product}
                    />
                  ))}
                </div>
              </div>
            )}

            {eventData && eventData?.length > 0 && (
              <div>
                <h3 className="text-base font-semibold mb-4">Our Events</h3>
                <div className="flex lg:flex-row flex-wrap gap-8">
                  {eventData?.map((event, index: number) => (
                    <CircularImage
                      key={`OurEvents-${index}`}
                      menuItem={event}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="flex flex-col-reverse md:flex-row justify-between lg:items-center mt-8">
            <div className="lg:w-1/2">
              <p className="text-[10px] md:text-xs text-white/60">{`Copyright ${new Date().getFullYear()} People Matters ${siteType === "IN" ? "Media Pvt. Ltd" : "Pte. Ltd"}. All rights reserved.`}</p>
            </div>
            <div className="grid w-full grid-cols-3 gap-3 lg:flex md:space-x-6 lg:w-1/2 lg:flex-row justify-between mb-4 md:mb-0">
              {(menuItems?.BottomMenu ?? []).map(({ label, href }) => (
                <Link
                  key={label}
                  href={href || "#"}
                  className="text-[10px] md:text-xs text-white/60 hover:text-white transition-colors"
                  prefetch={false}
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </footer>

      {/* <Script src={`${process.env.NEXT_PUBLIC_API_BASE_URL}/api/ads/ads.js?buster=${new Date().getTime()}&pathname=${window.location.pathname}`} async></Script> */}
    </div>
  );
};

export default MainFooter;
